// imports shared across all ORA templates
// imported from ORA entry points

// global imports
require('../../assets/shared');
require('../../assets/shared_functions');
require('../../site_scripts/mtc_vue_import');
require('../../site_scripts/mtc_read_more');
require('../../site_scripts/mtc_excerpt');
require('../../site_scripts/mtc_accordions');
// require('../../site_scripts/mtc_simple_form_submit');
require('../../site_scripts/mtc_lazy_load_recaptcha_form');
require('../../fpa/zapmap-overlay'); // todo: move this from fpa into a global dir?
require('../../ev-hub/tabs')
require('../../../../../core/js/plugins/mtc_slick');

// ORA imports
require('../modules/flyout-menu');
require('../modules/zapmap-tabs');
require('../modules/newsletter-signup');
